import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Button, Heading } from '../common';

const DesktopOnly = styled(Box)`
  align-self: stretch;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

function ScheduleHeader(props) {
  const {
    title,
    onRemove,
    onAdd,
    numOfRows,
    minRows,
    maxRows,
    ...restProps
  } = props;

  const renderDesktopLayout = () => {
    return (
      <Box
        height={48}
        flexDirection="row"
        display="flex"
        alignSelf="stretch"
        justifyContent="space-between"
        px={2}
        {...restProps}
      >
        <Heading px={2} py={0} my={0}>
          {title}
        </Heading>
        {(onAdd || onRemove) && (
          <Box flexDirection="row" display="flex" alignItems="center">
            <Button
              size="small"
              variant="secondary"
              mr={2}
              disabled={numOfRows <= minRows}
              onClick={() => {
                if (!onRemove) {
                  return;
                }
                onRemove();
              }}
            >
              Remove week
            </Button>
            <Button
              size="small"
              disabled={maxRows <= numOfRows}
              variant="secondary"
              onClick={() => {
                if (!onAdd) {
                  return;
                }
                onAdd();
              }}
            >
              Add week
            </Button>
          </Box>
        )}
      </Box>
    );
  };

  return <DesktopOnly>{renderDesktopLayout()}</DesktopOnly>;
}

ScheduleHeader.propTypes = {
  title: PropTypes.string,
  onRemove: PropTypes.func,
  onAdd: PropTypes.func,
  numOfRows: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number
};

export default ScheduleHeader;
